import { ImportActionsEnum } from '../enums/ImportActionsEnum';
import { IImportFilters } from '../interfaces/IImportFilters';
import { IImportState } from '../interfaces/IImportState';
import { ImportAction } from '../type/ImportAction';

const initialFilters: IImportFilters = {
  fileTypes: [],
  statuses: [],
};

const initial: IImportState = {
  data: [],
  order: null,
  page: 0,
  pageCount: 0,
  totalCount: 0,
  searchValue: '',
  isCurrentUser: false,
  filters: initialFilters,
};

export function importReducer(state = initial, action: ImportAction) {
  switch (action.type) {
    case ImportActionsEnum.IMPORT_SET_SEARCH_VALUE: {
      const newState: IImportState = {
        ...state,
        searchValue: action.payload.value,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_ORDER: {
      const { order } = action.payload;
      const newState: IImportState = {
        ...state,
        order,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_CURRENT_USER: {
      const { isCurrentUser } = action.payload;
      const newState: IImportState = {
        ...state,
        isCurrentUser,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_FILTERS: {
      const { filters } = action.payload;
      const newState: IImportState = {
        ...state,
        filters,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_TEMPLATE: {
      const { template } = action.payload;
      const newState: IImportState = {
        ...state,
        template,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_DATA: {
      const { data, page, totalCount, pageCount } = action.payload;
      const newState: IImportState = {
        ...state,
        data,
        page,
        pageCount,
        totalCount,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_KNO_ORGANIZATION_ID: {
      const { knoOrganizationId } = action.payload;
      const newState: IImportState = {
        ...state,
        knoOrganizationId,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_KNO_ORGANIZATION_ERVK_ID: {
      const { knoOrganizationErvkId } = action.payload;
      const newState: IImportState = {
        ...state,
        knoOrganizationErvkId,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_SUPERVISION_TYPE_ERVK_ID: {
      const { supervisionTypeErvkId } = action.payload;
      const newState: IImportState = {
        ...state,
        supervisionTypeErvkId,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_KNM_TYPE_ID: {
      const { knmTypeId } = action.payload;
      const newState: IImportState = {
        ...state,
        knmTypeId,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_SUBJECT_TYPE_ID: {
      const { subjectTypeId } = action.payload;
      const newState: IImportState = {
        ...state,
        subjectTypeId,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_SUBJECT_TYPE_ERVK_ID: {
      const { subjectTypeErvkId } = action.payload;
      const newState: IImportState = {
        ...state,
        subjectTypeErvkId,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_RESET_UPLOAD_MODAL_STORE: {
      const {
        knoOrganizationId,
        knoOrganizationErvkId,
        supervisionTypeErvkId,
        subjectTypeId,
        subjectTypeErvkId,
        knmTypeId,
      } = initial;
      const newState: IImportState = {
        ...state,
        knoOrganizationId,
        knoOrganizationErvkId,
        supervisionTypeErvkId,
        subjectTypeId,
        subjectTypeErvkId,
        knmTypeId,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_PLAN_TYPE: {
      const { planTypeWithFederalLaw } = action.payload;
      const newState: IImportState = {
        ...state,
        planTypeWithFederalLaw,
      };

      return newState;
    }
    case ImportActionsEnum.IMPORT_SET_FEDERAL_LAW: {
      const { federalLaw } = action.payload;
      const newState: IImportState = {
        ...state,
        federalLaw,
      };

      return newState;
    }
    default:
      return state;
  }
}
